import { ApplicationConfig } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { COMMON_PROVIDERS, MOCKS, STANDALONE_PROVIDERS } from '@core/init';
import { routes } from './app.routes.development.standalone';

export const appConfig: ApplicationConfig = {
  providers: [
    COMMON_PROVIDERS,
    provideRouter(routes, withRouterConfig({ onSameUrlNavigation: 'reload' })),
    STANDALONE_PROVIDERS,
  ],
};
